import _ from 'lodash'
import $ from 'jquery'
import fullcalendar from 'fullcalendar'
import moment from 'moment-timezone'

export default {
	name : 'date-field',
	props : ['data'],
	data () {
		return {
			field : {
				fakeValue : this.data.fakeValue,
				value     : this.data.value
			},
			calendar : {
				active : false
			}
		}
	},
	methods : {
		createFullCalendar () {

			let vm = this
			vm.calendar.active = true

			let calendarConfig = {
				header        : {
					left   : 'prevYear,prev',
					center : 'title',
					right  : 'next,nextYear'
				},
				prev          : 'left-single-arrow',
				next          : 'right-single-arrow',
				prevYear      : 'left-double-arrow',
				nextYear      : 'right-double-arrow',
				monthNames    : [
					this.$t('calendar.month_names.january'),
					this.$t('calendar.month_names.february'),
					this.$t('calendar.month_names.march'),
					this.$t('calendar.month_names.april'),
					this.$t('calendar.month_names.may'),
					this.$t('calendar.month_names.june'),
					this.$t('calendar.month_names.july'),
					this.$t('calendar.month_names.august'),
					this.$t('calendar.month_names.september'),
					this.$t('calendar.month_names.october'),
					this.$t('calendar.month_names.november'),
					this.$t('calendar.month_names.december')
				],
				dayNamesShort : [
					this.$t('calendar.day_names_short.sunday'),
					this.$t('calendar.day_names_short.monday'),
					this.$t('calendar.day_names_short.tuesday'),
					this.$t('calendar.day_names_short.wednesday'),
					this.$t('calendar.day_names_short.thursday'),
					this.$t('calendar.day_names_short.friday'),
					this.$t('calendar.day_names_short.saturday')
				],
				dayClick      : function(date, jsEvent, view) {

					jsEvent.preventDefault()

					if( !$(this).hasClass('disabled') ){

						$('.calendar.active').removeClass('active')

						$(this).addClass('active')

						let dateSelected = moment(date.format()).format('YYYY-MM-DD')

						vm.field.fakeValue = moment(date.format()).format('DD-MM-YYYY')

						vm.field.value = dateSelected

						vm.calendar.active = false

						vm.$emit('changeData', dateSelected)

					}

				},
				viewRender    : function(view){

					//$('.calendar .fc-day.fc-past').addClass('disabled')
					//$('.calendar .fc-day-number.fc-past').addClass('disabled')

				}
			}

			setTimeout(() => {

				$('.calendar').fullCalendar(calendarConfig)

			}, 100)

		}
	}
}



// WEBPACK FOOTER //
// ./src/components/general/fields/date/script.js